import { useState } from 'react'
import { ExternalLink } from 'lucide-react'
import { resolveBookIdentity } from '../lib/bookLogoRegistry.js'

function isSuspicious(value) {
  const number = Number(value)
  return Number.isFinite(number) && (number === 0 || Math.abs(number) < 100 || Math.abs(number) > 10_000)
}

function formatOdds(value, format) {
  const number = Number(value)
  if (!Number.isFinite(number)) return 'unpriced'
  if (format === 'american') return number > 0 ? `+${number}` : String(number)
  if (number >= 100) return (1 + number / 100).toFixed(2)
  if (number <= -100) return (1 + 100 / Math.abs(number)).toFixed(2)
  return 'n/a'
}

function BookCell({ book }) {
  const identity = resolveBookIdentity(book)
  const [failed, setFailed] = useState(false)
  return (
    <span className="lovx-exact-book" title={identity.logoStatus}>
      {identity.logoUrl && !failed
        ? <img src={identity.logoUrl} alt="" onError={() => setFailed(true)} />
        : <span>{identity.displayName.slice(0, 2)}</span>}
      <strong>{identity.displayName}</strong>
    </span>
  )
}

function flatten(groups) {
  return groups.flatMap((group) => group.rows.map((row, index) => ({ group, row, index })))
}

export default function LiveOddsVNextExactTable({ groups, oddsFormat, onInspect }) {
  const rows = flatten(groups)
  return (
    <div className="lovx-exact-wrap">
      <table className="lovx-exact-table">
        <thead><tr>
          <th>League / event</th><th>Date / time</th><th>Period</th><th>Market</th><th>Selection</th><th>Line</th><th>Sportsbook</th><th>Price</th><th>State</th><th>PID</th><th aria-label="Inspect" />
        </tr></thead>
        <tbody>{rows.map(({ group, row, index }) => {
          const suspicious = isSuspicious(row.american)
          return (
            <tr key={`${group.key}|${row.book}|${row.pid ?? index}|${index}`}>
              <td className="lovx-exact-event"><span>{group.league || '—'}</span><strong>{group.event || 'Unknown event'}</strong></td>
              <td><strong>{group.et_date || '—'}</strong><span>{group.et_time || '—'}</span></td>
              <td>{group.period || 'Game'}</td>
              <td>{group.bet_type || 'Unknown'}</td>
              <td className="lovx-exact-selection">{group.selection || 'Unknown'}</td>
              <td className="lovx-number">{group.line ?? '—'}</td>
              <td><BookCell book={row.book} /></td>
              <td className={`lovx-number lovx-raw-price ${suspicious ? 'suspicious' : ''}`} title={suspicious ? `Suspicious raw American odds preserved: ${row.american}` : ''}>
                {formatOdds(row.american, oddsFormat)}{suspicious && <small>raw {String(row.american)}</small>}
              </td>
              <td><span className={`lovx-state lovx-state-${String(row.state || 'unknown').toLowerCase()}`}>{row.state || 'unknown'}</span></td>
              <td className="lovx-pid">{row.pid ?? '—'}</td>
              <td><button type="button" className="lovx-row-open" onClick={() => onInspect(row)} title="Inspect raw offer"><ExternalLink size={13} /></button></td>
            </tr>
          )
        })}</tbody>
      </table>
    </div>
  )
}
